module.exports = __webpack_public_path__ + "static/media/sign-out.f1a8c277.svg";